import React from "react";
import { Card, CardMedia, CardContent, Typography, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg';
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp';
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg';
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg';
import garlicGranulesImage from './images/GarlicGranules.jpg';
import tomatoImage from './images/istockphoto-98026003-612x612.jpg';

const productOptions = [
  {
    title: "Dehydrated White Onions",
    image: whiteOnionGranulesImage,
    link: "/detailed-products-white-onion",
  },
  {
    title: "Dehydrated Pink Onions",
    image: pinkOnionGranulesImage,
    link: "/detailed-products-pink-onion",
  },
  {
    title: "Dehydrated Red Onions",
    image: redOnionGranulesImage,
    link: "/detailed-products-red-onion",
  },
  {
    title: "Fried Onion & Garlic",
    image: friedCoatedPinkOnionImage,
    link: "/detailed-products-fried-onions",
  },
  {
    title: "Dehydrated Garlic",
    image: garlicGranulesImage,
    link: "/detailed-products-garlic",
  },
  {
    title: "Vegetables Powder & Spices",
    image: tomatoImage,
    link: "/detailed-products-vegetable-powders-and-spices",
  },
];

const Commonredirects = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        width: "100%",
        background: 'linear-gradient(135deg,rgb(0, 0, 0),rgb(0, 0, 0))',
        color: "white",
        padding: "40px",
        textAlign: "center",
      }}
    >
      {/* Animated Heading */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: "bold", textTransform: "uppercase" }}
        >
          Also Explore
        </Typography>
      </motion.div>

      <Grid container spacing={3} justifyContent="center">
        {productOptions.map((product, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            {/* Animated Card */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <Link to={product.link} style={{ textDecoration: "none" }} onClick={() => window.scrollTo({ top: 0, left: 0 })}>
                <Card
                  sx={{
                    background: 'linear-gradient(135deg,rgb(13, 14, 13),rgb(20, 33, 21))',
                    color: "white",
                    borderRadius: "15px",
                    overflow: "hidden",
                    transition: "transform 0.3s",
                    "&:hover": { transform: "scale(1.05)" },
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ minHeight: 100, maxHeight: 300 }}
                    image={product.image}
                    alt={product.title}
                  />
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {product.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Commonredirects;
